// ─── App route table — extracted from App.js ─────────────────────────────
// Lazy-load later if bundle size grows. For now, import components directly
// so Webpack can tree-shake exactly as before.
import Dashboard from '../pages/Dashboard';
import Sales from '../pages/Sales';
import SalesPipeline from '../pages/SalesPipeline';
import Purchases from '../pages/Purchases';
import Inventory from '../pages/Inventory';
import Production from '../pages/Production';
import Cashflow from '../pages/Cashflow';
import Workforce from '../pages/Workforce';
import Compliance from '../pages/Compliance';
import Reports from '../pages/Reports';
import Vouchers from '../pages/Vouchers';
import Accounting from '../pages/Accounting';
import TaskManager from '../pages/TaskManager';
import Users from '../pages/Users';
import RnD from '../pages/RnD';
import Samples from '../pages/Samples';
import Notifications from '../pages/Notifications';
import NotificationPreferences from '../pages/NotificationPreferences';
import InwardLot from '../pages/InwardLot';
import AdminPortalOrders from '../pages/AdminPortalOrders';
import AdminPortalAccounts from '../pages/AdminPortalAccounts';
import Clients from '../pages/Clients';
import Debtors from '../pages/Debtors';
import Creditors from '../pages/Creditors';
import AnalyticsPage from '../pages/AnalyticsPage';
import POCalendar from '../pages/POCalendar';
import PurchaseCalendar from '../pages/PurchaseCalendar';
import DispatchCalendar from '../pages/DispatchCalendar';
import ProcurementIntelligence from '../pages/ProcurementIntelligence';
import BillLog from '../pages/BillLog';
import Enterprise from '../pages/Enterprise';
import IntelligenceSuite from '../pages/IntelligenceSuite';
import WhatsAppBot from '../pages/WhatsAppBot';
import CreditorReminders from '../pages/CreditorReminders';
import DebtorReminders from '../pages/DebtorReminders';
import StockDebts from '../pages/StockDebts';
import AIMemory from '../pages/AIMemory';
import RnDChains from '../pages/RnDChains';
import Inbox from '../pages/Inbox';
import PriceAuditLog from '../pages/PriceAuditLog';
import ReorderSuggestions from '../pages/ReorderSuggestions';
import CostVariance from '../pages/CostVariance';
import FestivePlanner from '../pages/FestivePlanner';
import QCTasks from '../pages/QCTasks';
import ProductionTasks from '../pages/ProductionTasks';
import DailySummary from '../pages/DailySummary';
import ProductCodes from '../pages/ProductCodes';
import Transformations from '../pages/Transformations';
import HistoricalData from '../pages/HistoricalData';
import FinancialReports from '../pages/FinancialReports';
import BackupExport from '../pages/BackupExport';
import SalesCalendar from '../pages/SalesCalendar';
import LotHistory from '../pages/LotHistory';
import TrackingDispatches from '../pages/TrackingDispatches';
import Insights from '../pages/Insights';
import ProcurementAnalytics from '../pages/ProcurementAnalytics';
import AliasManager from '../pages/AliasManager';
import Loans from '../pages/Loans';
import Overdrafts from '../pages/Overdrafts';
import BankReconciliation from '../pages/BankReconciliation';
import CreditCards from '../pages/CreditCards';
import Expenses from '../pages/Expenses';
import Profitability from '../pages/Profitability';
import FactoryCommandCenter from '../pages/FactoryCommandCenter';

export const ADMIN_ROUTES = [
  { path: '/dashboard',  component: Dashboard,                              perm: 'dashboard' },
  { path: '/sales',      component: SalesPipeline,                          perm: 'sales_pipeline' },
  { path: '/sales-legacy', component: Sales,                                perm: 'sales' },
  { path: '/purchases',  component: Purchases,                              perm: 'purchases' },
  { path: '/inventory',  component: Inventory,                              perm: 'inventory' },
  { path: '/production', component: Production,                             perm: 'production' },
  { path: '/factory-command-center', component: FactoryCommandCenter,        perm: 'production' },
  { path: '/cashflow',   component: Cashflow,                               perm: 'cashflow' },
  { path: '/expenses',   component: Expenses,                               perm: 'expenses' },
  { path: '/profitability', component: Profitability,                       perm: 'profitability' },
  { path: '/loans',      component: Loans,                                  perm: 'loans' },
  { path: '/overdrafts', component: Overdrafts,                             perm: 'overdrafts' },
  { path: '/credit-cards', component: CreditCards,                          perm: 'credit_cards' },
  { path: '/bank-reconciliation', component: BankReconciliation,            perm: 'bank_reconciliation' },
  { path: '/workforce',  component: Workforce,                              perm: 'workforce' },
  { path: '/compliance', component: Compliance,                             perm: 'compliance' },
  { path: '/reports',    component: Reports,                                perm: 'reports' },
  { path: '/vouchers',   component: Vouchers,                               perm: 'vouchers' },
  { path: '/accounting', component: Accounting,                             perm: 'accounting' },
  { path: '/tasks',      component: TaskManager,                            perm: 'tasks' },
  { path: '/users',      component: Users,                                  perm: 'user_management' },
  { path: '/whatsapp-bot', component: WhatsAppBot,                          perm: 'user_management' },
  { path: '/rnd',        component: RnD,                                    perm: 'rnd' },
  { path: '/samples',    component: Samples,                                perm: 'samples' },
  { path: '/notifications', component: Notifications,                       perm: 'notifications' },
  { path: '/notifications/preferences', component: NotificationPreferences, perm: 'notifications' },
  { path: '/inward-lot', component: InwardLot,                              perm: 'inventory' },
  { path: '/clients',    component: Clients,                                perm: 'sales' },
  { path: '/debtors',    component: Debtors,                                perm: 'debtors' },
  { path: '/creditors',  component: Creditors,                              perm: 'creditors' },
  { path: '/analytics/:type', component: AnalyticsPage,                     perm: 'reports' },
  { path: '/po-calendar',        component: POCalendar,                     perm: 'sales_calendar' },
  { path: '/purchase-calendar',  component: PurchaseCalendar,               perm: 'purchase_calendar' },
  { path: '/dispatch-calendar',  component: DispatchCalendar,               perm: 'sales_calendar' },
  { path: '/procurement-ai',     component: ProcurementIntelligence,        perm: 'procurement_intelligence' },
  { path: '/bill-log',           component: BillLog,                        perm: 'vouchers' },
  { path: '/enterprise',         component: Enterprise,                     perm: 'vouchers' },
  { path: '/intelligence',       component: IntelligenceSuite,              perm: 'feature_ai_features' },
  { path: '/creditor-reminders', component: CreditorReminders,              perm: 'creditor_reminders' },
  { path: '/debtor-reminders',   component: DebtorReminders,                perm: 'debtor_reminders' },
  { path: '/stock-debts',        component: StockDebts,                     perm: 'stock_debts' },
  { path: '/ai-memory',          component: AIMemory,                       perm: 'feature_grievances_widget' },
  { path: '/rnd-chains',         component: RnDChains,                      perm: 'rnd' },
  { path: '/inbox',              component: Inbox,                          perm: 'notifications' },
  { path: '/price-audit',        component: PriceAuditLog,                  perm: 'price_audit_log' },
  { path: '/reorder',            component: ReorderSuggestions,             perm: 'inventory' },
  { path: '/cost-variance',      component: CostVariance,                   perm: 'reports' },
  { path: '/festive-planner',    component: FestivePlanner,                 perm: 'feature_ai_features' },
  { path: '/qc',                 component: QCTasks,                        perm: 'quality_check' },
  { path: '/production-tasks',   component: ProductionTasks,                perm: 'production' },
  { path: '/daily-summary',      component: DailySummary,                   perm: 'production' },
  { path: '/transformations',    component: Transformations,                perm: 'transformations' },
  { path: '/product-codes',      component: ProductCodes,                   perm: 'item_codes' },
  { path: '/historical-data',    component: HistoricalData,                 perm: 'historical_data' },
  { path: '/financial-reports',  component: FinancialReports,               perm: 'financial_reports' },
  { path: '/admin/portal-orders',   component: AdminPortalOrders,           perm: 'admin_portal_orders' },
  { path: '/admin/portal-accounts', component: AdminPortalAccounts,         perm: 'admin_portal_accounts' },
  { path: '/backup',                component: BackupExport,                perm: 'backup' },
  { path: '/sales-calendar',        component: SalesCalendar,               perm: 'sales_calendar' },
  { path: '/tracking-dispatches',   component: TrackingDispatches,          perm: 'sales_calendar' },
  { path: '/lot-history',           component: LotHistory,                  perm: 'inventory' },
  { path: '/insights',              component: Insights,                    perm: 'reports' },
  { path: '/procurement-analytics', component: ProcurementAnalytics,        perm: 'reports' },
  { path: '/aliases',               component: AliasManager,                perm: 'user_management' },
];
